import { useEffect } from 'react';

const useScrollToTop = (dependencies = []) => {
	useEffect(() => {
		// Используем window.scrollTo с плавной анимацией
		window.scrollTo({
			top: 0,
			left: 0,
			behavior: 'smooth'
		});

		// Дополнительно скроллим body для надежности
		document.body.scrollTo({
			top: 0,
			left: 0,
			behavior: 'smooth'
		});

		// И html элемент тоже
		document.documentElement.scrollTo({
			top: 0,
			left: 0,
			behavior: 'smooth'
		});
	}, dependencies);
};

export default useScrollToTop; 